import { render } from "./UsersIcon.vue?vue&type=template&id=537aea27"
const script = {}

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__